import React from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';

import { DSTheme } from '../../../styles/themes/types';
import MoonIcon from '../../../assets/icons/moon';
import SunIcon from '../../../assets/icons/sun';

type PropsType = {
  onClick: () => void;
  theme: Theme;
};

const useStyles = makeStyles((theme: DSTheme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    width: '64px',
    height: '64px',
    borderRadius: '16px',
    backgroundColor: theme.palette.background.elevation1,
    boxShadow: '0px 5px 45px rgba(128, 129, 145, 0.18)',

    cursor: 'pointer',
  },
}));

const ThinToggle: React.FC<PropsType> = ({ onClick, theme }) => {
  const classes = useStyles();

  return (
    <div aria-label="ThemeToggle" role="button" className={classes.container} onClick={onClick}>
      {theme.palette.type === 'dark' ? (
        <MoonIcon stroke={theme.palette.text.primary} />
      ) : (
        <SunIcon stroke={theme.palette.text.secondary} />
      )}
    </div>
  );
};

export default ThinToggle;
